module.exports = __webpack_public_path__ + "static/kuat_washing_paste_lemon-33d35be7619b37f80932b82b7015f088.png";